<template>
    <div>
        <h1>Redirect Test</h1>
    </div>
</template>

<script>
export default {
    name: "WebPartnerMarketingRedirectTest",
}
</script>
